import { LegalPage } from "./LegalPage.jsx";

const DEMO_HTML = `
<p>
  By accessing this website and engaging with Shere-e-Punjab Homes Pty Ltd
  ("Shere-e-Punjab Homes", "we", "us") you agree to the following terms.
  Please read them in full before submitting an enquiry, signing a quote,
  or attending a display home.
</p>

<h2>1. Use of this website</h2>
<p>
  Content on this website (designs, floor plans, renders, blog posts,
  photography, copy) is owned by Shere-e-Punjab Homes or licensed to us. You
  may view and download content for personal, non-commercial purposes only.
  Reuse, republication, or redistribution requires written permission.
</p>
<p>
  We make every effort to keep specifications, pricing, and inclusion lists
  current, but website content is indicative only. Final pricing and final
  inclusions are confirmed at contract.
</p>

<h2>2. Quotes and proposals</h2>
<p>
  Any quote or proposal we issue is valid for 30 days from the issue date
  unless stated otherwise. After 30 days material costs, council fees, or
  finance terms may have moved and pricing may need to be re-issued.
</p>
<p>
  Acceptance of a quote does not constitute a binding contract — a binding
  contract is formed only when both parties sign the formal HIA or
  Master Builders contract document.
</p>

<h2>3. Site visits and display homes</h2>
<p>
  Display homes are open during posted hours and at private appointment.
  Children must be supervised at all times. We reserve the right to refuse
  entry to anyone behaving disruptively or photographing in a way that
  could compromise the privacy of other guests.
</p>

<h2>4. Variations and changes</h2>
<p>
  Once a build contract is signed, variations are processed in writing and
  invoiced separately. Verbal agreements with site supervisors are not
  binding — every change must be confirmed via a signed variation order.
</p>

<h2>5. Liability</h2>
<p>
  To the extent permitted by law, our liability is limited to the value of
  the build contract. We are not liable for indirect, consequential, or
  third-party losses including delayed sale of an existing property,
  alternative accommodation costs, or relocation expenses.
</p>

<h2>6. Statutory warranties</h2>
<p>
  All builds carry the implied warranties under the <em>Domestic Building
  Contracts Act 1995 (Vic)</em>, including fitness for purpose, compliance
  with plans, and use of suitable materials. Statutory warranties cannot be
  excluded by these terms.
</p>

<h2>7. Updates to these terms</h2>
<p>
  We may update these terms from time to time. Material changes will be
  posted to this page with an updated effective date. Continued use of the
  website after changes are posted constitutes acceptance.
</p>

<h2>8. Contact</h2>
<p>
  Questions about these terms? Email
  <a href="mailto:legal@sherepunjabhomes.com.au">legal@sherepunjabhomes.com.au</a>
  or call our office during business hours.
</p>

<p><em>This is demo content for development purposes. Replace with terms reviewed by your solicitor before going live.</em></p>
`;

export default function TermsPage() {
  return (
    <LegalPage
      field="termsConditions"
      title="Terms & Conditions"
      description="The terms governing use of the Shere-e-Punjab Homes website and services."
      demoHtml={DEMO_HTML}
    />
  );
}
